export const pathJoin = (...paths: string[]): string => {
  return paths.reduce((acc, path) => {
    if (path !== '') {
      const cleanedPath = path.replace(/^\/+|\/+$/g, '');
      if (acc) {
        return `${acc}/${cleanedPath}`;
      }
      return cleanedPath;
    }
    return acc;
  }, '');
};
